import React from 'react';

import type { SearchAllContentVacancyHit as Type } from '../../../../SearchAllContent/types';

import NodeVacancyCard from '../../../../../implementations/Node/Vacancy/Card';

const MetaSearchArticleHit: React.FC<{ hit: Type }> = ({ hit }) => (
  <NodeVacancyCard
    title={hit.page_title[0]}
    subtitle={hit.body?.[0]}
    link={hit.link_url[0]}
    departments={hit.departments_name}
    locations={hit.locations_name}
  />
);

export default MetaSearchArticleHit;
